import { __rest } from "tslib";
import { createElement } from 'rax';
import classNames from 'classnames';
import View from '../view';
const SafeArea = (props) => {
    const { prefix = 'mt-', className, style } = props, others = __rest(props, ["prefix", "className", "style"]);
    return <View {...others} className={classNames(`${prefix}safe-area`, className)}/>;
};
SafeArea.displayName = 'SafeArea';
export default SafeArea;
